import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-white overflow-hidden" data-id="element-125">
      {/* Top Bar */}
      <div className="bg-brand-navy text-white py-2 px-4 flex items-center justify-center gap-2 text-sm font-medium" data-id="element-126">
        <div className="flex items-center gap-0.5" data-id="element-127">
          {[...Array(4)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-128" />)}
          <div className="relative w-4 h-4" data-id="element-129">
            <Star className="w-4 h-4 text-slate-500 fill-current absolute inset-0" data-id="element-130" />
            <div className="absolute inset-0 overflow-hidden" style={{
            width: '80%'
          }} data-id="element-131">
              <Star className="w-4 h-4 text-yellow-400 fill-current" data-id="element-132" />
            </div>
          </div>
        </div>
        <span className="text-center" data-id="element-133">
          4.8/5 — Padres que encontraron un sistema, no solo consejos
        </span>
      </div>

      <div className="pt-8 pb-10 md:pt-16 md:pb-20 px-5" data-id="element-134">
        <div className="max-w-4xl mx-auto text-center" data-id="element-135">
          <FadeIn data-id="element-136">
            <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl text-brand-navy leading-tight mb-4 font-bold" data-id="element-137">
              Detén las rabietas y las luchas de poder en casa hoy mismo sin
              gritos ni culpas.
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-138">
            <p className="font-sans text-base md:text-xl text-slate-700 leading-relaxed mb-6 max-w-3xl mx-auto" data-id="element-139">
              El método de 3 pasos que está ayudando a madres en USA a detener
              una rabieta en menos de 60 segundos, sin gritar y sin sentirse mal
              después.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-140">
            <div className="relative w-full max-w-3xl mx-auto rounded-2xl overflow-hidden shadow-2xl mb-6" data-id="element-141">
              <img src="https://cdn.magicpatterns.com/uploads/2WjjPjcopDXBHmrP164y5s/imagen_3.png" alt="Madre agotada rodeada de caos en casa" className="object-cover w-full h-auto" data-id="element-142" />
            </div>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-143">
            <CTAButton mainText="¡SÍ, QUIERO EL PLAN DE 21 DÍAS!" subText="⚡ Acceso inmediato por solo $7 · Pago único · Sin suscripciones" href="#final-cta" data-id="element-144" />
          </FadeIn>
        </div>
      </div>
    </section>;
}